export const getISODateAndMonth = date => {
    if (date) {
        return { month: date.getMonth() + 1, year: date.getFullYear() };
    }
    return null;
};

export const getISOFromDateAndMonth = date => {
    if (date?.month && date?.year) {
        return new Date(date.year, date.month - 1, 1);
    }
    return null;
};

export const getISOFromYear = year => {
    if (year) {
        return new Date(year, 0, 1).toISOString();
    }
    return null;
};
